import { render, staticRenderFns } from "./GroupLevels.vue?vue&type=template&id=4a628a9d&scoped=true&"
import script from "./GroupLevels.vue?vue&type=script&lang=js&"
export * from "./GroupLevels.vue?vue&type=script&lang=js&"
import style0 from "./GroupLevels.vue?vue&type=style&index=0&id=4a628a9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a628a9d",
  null
  
)

export default component.exports